export const FunctionReadingInventory = () => null;
